import { fetchData } from "@client";
import { inflate } from "pako";

export async function getSessionDataQuery(id) {
  const res = await fetchData(`/session/${id}`);
  return {
    ...res.results,
    session: Object.values(res.results.session).reduce((p, c) => {
      try {
        let parsed;
        if (res.results.compressed) {
          const unzipped = inflate(new Uint8Array(c.split(",")), { toText: true });
          parsed = JSON.parse(unzipped);
        } else parsed = JSON.parse(c);
        return [...p, ...(parsed.events || parsed)];
      } catch (e) {
        return p;
      }
    }, []),
  };
}
